import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import { ScrollContext } from 'react-router-scroll-4';
import 'antd/dist/antd.css'; 
import 'bootstrap/dist/css/bootstrap.min.css';
import './index.css';
import App from './components/App';
import reportWebVitals from './reportWebVitals';

//=================================================START PAGE=======================================================
import Login from './components/pages/login';
import ForgotPassword from './components/pages/forgotpass';
import RequestForgotPassword from './components/pages/reqforgotpass';
// ================================================END PAGE=========================================================


// ================================================START VIEW=======================================================
import Dashboard from './components/view/dashboard/index.component';
import UploadInvoice from './components/view/paid/upload.components';
import UploadNotaDebet from './components/view/nota/upload.components';
import UploadDispute from './components/view/dispute/index.components';

import BARDownload from './components/view/download/bar.components';
import InvoiceDownload from './components/view/download/invoice.components';
import FakturPajakDownload from './components/view/download/faktur.pajak.components';


import DocumentA from './components/view/download/doc.a.components';
import DocumentB from './components/view/download/doc.b.components';


// ================================================END VIEW=========================================================

if ("serviceWorker" in navigator) {
  navigator.serviceWorker
    .register(process.env.PUBLIC_URL+"/firebase-messaging-sw.js")
    .then(function(registration) {
      console.log("Registration successful, scope is:", registration.scope);
    })
    .catch(function(err) {
      console.log("Service worker registration failed, error:", err);
    });
}

class Root extends React.Component {

  render() {
    return (
      <BrowserRouter basename={'/'}>
          <ScrollContext>
            <Switch>
              <Route exact path={`${process.env.PUBLIC_URL}/login`} component={Login} />
              <Route exact path={`${process.env.PUBLIC_URL}/forgotpassword`} component={ForgotPassword} />
              <Route exact path={`${process.env.PUBLIC_URL}/reqforgotpass`} component={RequestForgotPassword} />
              <App>
                <Route path={`${process.env.PUBLIC_URL}/dashboard`} component={Dashboard} />
                <Route path={`${process.env.PUBLIC_URL}/invoice/upload`} component={UploadInvoice} />

                <Route path={`${process.env.PUBLIC_URL}/nota/upload`} component={UploadNotaDebet} />
                <Route path={`${process.env.PUBLIC_URL}/dispute/upload`} component={UploadDispute} />

                <Route path={`${process.env.PUBLIC_URL}/download/bar`} component={BARDownload} />
                <Route path={`${process.env.PUBLIC_URL}/download/invoice`} component={InvoiceDownload} />
                <Route path={`${process.env.PUBLIC_URL}/download/faktur_pajak`} component={FakturPajakDownload} />
                <Route path={`${process.env.PUBLIC_URL}/download/doc-a`} component={DocumentA} />
                <Route path={`${process.env.PUBLIC_URL}/download/doc-b`} component={DocumentB} />
              </App>
            </Switch>
          </ScrollContext>
      </BrowserRouter>
    );
  }
}


ReactDOM.render(<Root/>, document.getElementById('root'));
reportWebVitals();

// ReactDOM.render(
//   <React.StrictMode>
//     <App />
//   </React.StrictMode>,
//   document.getElementById('root')
// );

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals

